import React from 'react'
import { useEffect } from 'react'
import backgroundImg from '../images/logo.jpeg'
import down from '../images/down-arrow.svg'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import Typical from 'react-typical'
import Mission from "./Mission";
import Learn from "./Learn";
import Collaborate from "./Collaborate";
import backgroundvideo from './bg.mp4'
import './Home.css'
import WebFont from 'webfontloader';
import Footer from './Footer'
import Footer2 from './Footer2'

import { BrowserRouter, Route, Link } from "react-router-dom";



function Home(){

	useEffect(() => {
		WebFont.load({
		  google: {
			families: ['Droid Sans', 'Chilanka']
		  }
		});
	   }, []);

	return (
		<>
		
		<Wrap bgImage={backgroundImg}> {/* pass props */}
		<video autoPlay loop muted id='video'
           source src={backgroundvideo} type='video/mp4'>
        </video>
		<Wrapper>
			<RowWrapper>
			<Fade bottom>
				
				<ItemText>
					<Heading >CodeZen</Heading>
					<h3>By Captivators</h3>
				</ItemText>
			</Fade>
            
            <Fade bottom>
            <span id=''>
             <pre>
            <h1 >A community driven by </h1>
            </pre>
            <pre>   
            <Typical loop={Infinity}
              wrapper = "h1"
              steps={[
                "Passion 💥",
                1000,
                "Collaboration 🤝",
                1000,
                "Creativity 😎 ",
                1000,
                "Learning 💻 ",
                1000,
                "Insipiration 🏆 ",
                1000,
              ]}
            ></Typical>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            </pre>
            </span>

            </Fade>
			<Buttons>
				<Fade bottom>
					<ButtonGroup>
						<LeftButton>
						    <Link to="/contact" className='link'>Join Now</Link>
						</LeftButton>
						
						<RightButton >
							<Link to="#mis" className='link2'>Learn More</Link>
						</RightButton>
					
					</ButtonGroup>
				</Fade>
				
				
			</Buttons>
			</RowWrapper>
		 </Wrapper>
		 <DownArrow src={down} />
		</Wrap>

		
         
		 <Wrap>
		 <Mission id='mis'/>
         <Learn />
         <Collaborate />
		 <Footer />
		 <Footer2 />
		 </Wrap>
		</>
	)
}

export default Home;

const Heading = styled.div`
    font-size : 80px;
	
`

const Wrap = styled.div `
	min-width: 100vw;
	min-height: 100vh;
	background-size: cover; /* set size to cover */
	background-position: center; /* center the image */
	background-repeat: no-repeat; /* dont repeat the background */

	display: flex;
	flex-direction: column; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */

	background-image: ${props => `url("/images/${props.bgImage}")`};
	@media (min-width: 767px) {
		
		color : white;
	
}
`
const Wrapper = styled.div`
  position: relative;
  
  height: auto;
  padding: 1rem;
  background: rgba(15, 14, 71, 0.3);
  box-shadow: 0px 30px 60px rgba(0, 0, 0, 0.25),
    inset 0 0 0 0.5px rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  backdrop-filter: blur(3px);
  margin-top: 100px;
`;

const RowWrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
	flex-direction: column; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */
`;

const ItemText = styled.div `
	padding-top: 2vh;
	text-align: center;
	@media (min-width: 767px) {
		
		color : rgb(23, 126, 2);
	
}
`
const ButtonGroup = styled.div `
	display: flex;
	margin-bottom: 30px;

	@media (max-width: 768px){
		flex-direction: column;
	}
`

const LeftButton = styled.div `
	background-color: green;
	height: 40px;
	width: 256px;
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 100px;
	opacity: 0.85;
	text-transform: uppercase;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	letter-spacing: 1px;
	margin: 8px;
`
const RightButton = styled(LeftButton) `
	background-color: white;
	opacity: 0.65;
	color: black;	
    border : 2px solid green;
`

const DownArrow = styled.img `
	height: 40px;
	animation: animationDown infinite 1.5s;
	overflow-x: hidden;
`
const Buttons = styled.div `
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`

const Punch = styled.div `
width: 100vw;
height: 100vh;
background-size: cover; /* set size to cover */
background-position: center; /* center the image */
background-repeat: no-repeat; /* dont repeat the background */

display: flex;
flex-direction: row; /* switch to vertical */
 justify-content: center; /* horizontal alignment */
align-items: center; /* vertical alignment */

background-image: ${props => `url("/images/${props.bgImage}")`};
`